import { render } from "./FilterModal.vue?vue&type=template&id=08fafc48&scoped=true"
import script from "./FilterModal.vue?vue&type=script&lang=js"
export * from "./FilterModal.vue?vue&type=script&lang=js"

import "./FilterModal.vue?vue&type=style&index=0&id=08fafc48&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08fafc48"]])

export default __exports__